module.exports = __webpack_public_path__ + "img/transport.a30d34ff.png";